import { associateRequestTableColumns } from '../../constants/tableColumns';
import useAssociateRequestActions from '../../hooks/APIHooks/users/useAssociateRequestActions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';

const ShowAllAssociateRequests = () => {
  // integration of API hooks here
  const { getRequestListHandler } =
    useAssociateRequestActions('getRequestList');

  console.log('ASSOCIATE REQUEST LIST: ', getRequestListHandler.data?.data);

  // rendering show all associate requests section component here
  return (
    <section>
      {getRequestListHandler.isLoading ? (
        <AcademiaLoading />
      ) : getRequestListHandler.isSuccess ? (
        <>
          <PageHeader headerText='Associate Requests' />

          <AcademiaTable
            data={getRequestListHandler.data.data}
            columns={associateRequestTableColumns}
            notFoundMessage='No associate request found!'
          />
        </>
      ) : getRequestListHandler.isError ? (
        <AcademiaNotFound message='Failed to load associate request data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllAssociateRequests;
